/**
 * Real Services — wrappers around current API integrations
 *
 * Used when appMode === 'real'. Delegates to existing api.js services.
 */
export { DictationService, FhirService } from './api';

import {
  lensExtract, lensExtractAndWait, lensPollJob,
  lensListJobs, lensDeleteJob, lensRetryJob,
} from './lensService';

// FHIR Subscriptions (live API calls)
const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const _get = async (path) => {
  const res = await fetch(`${API_URL}${path}`);
  if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
  return res.json();
};

export const FhirSubscriptionService = {
  getStatus: () => _get('/api/fhir/subscriptions/status'),
  getEvents: (limit = 50) => _get(`/api/fhir/subscriptions/events?limit=${limit}`),
  getQueue: (limit = 50) => _get(`/api/fhir/subscriptions/queue?limit=${limit}`),
};

// Lens — full API surface delegating to lensService.js
export const LensService = {
  analyze: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const token = localStorage.getItem('ariaone-token');
    const h = {};
    if (token) h['Authorization'] = `Bearer ${token}`;
    const res = await fetch(`${API_URL}/api/lens/analyze`, {
      method: 'POST',
      headers: h,
      body: formData,
    });
    if (!res.ok) throw new Error(`Lens analyze failed: ${res.status}`);
    return res.json();
  },
  extract: lensExtract,
  extractAndWait: lensExtractAndWait,
  pollJob: lensPollJob,
  listJobs: lensListJobs,
  deleteJob: lensDeleteJob,
  retryJob: lensRetryJob,
};
